var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'circle-loader': true,
    'load-complete': !_vm.loading,
    success: _vm.loading || _vm.success,
    'danger dangery': !_vm.loading && !_vm.success,
  }},[(!_vm.loading && _vm.success)?_c('div',{class:{ checkmark: _vm.success, draw: !_vm.loading }}):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[(!_vm.loading && !_vm.success)?_c('p',[_c('b-icon',{staticClass:"fa-throb is-exclamation",attrs:{"icon":"exclamation","type":"is-danger","size":"is-large"}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }